import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Badge, Button, Popconfirm } from "antd";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

const isAlbumNotForSale = (item) =>
  item.not_for_sale === true ||
  item.not_for_sale === 1 ||
  item.not_for_sale === "1";

export const albumListColumns = (deleteMutation, token, setLoading, router) => {
  return [
    {
      title: "ID",
      dataIndex: "id",
      width: 60,
    },
    {
      title: i18n.t("course.album.name"),
      render: (item) => {
        return (
          <div className="info">
            <div className="cover">
              <img
                src={i18n.getPropNameByLocale(item, "cover") || "/placeholder.png"}
                alt={i18n.getPropNameByLocale(item, "name")}
                width={130}
                height={88}
                style={{ objectFit: "cover" }}
              />
            </div>
            <div className="name">
              <span>{i18n.getPropNameByLocale(item, "name")}</span>
              <span style={{ color: "#999", fontSize: "12px" }}>
                {i18n.t("course.album.coursesCount")}: {item.courses?.length || 0}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: i18n.t("course.categoryName"),
      render: (item) => {
        return <span>{i18n.getPropNameByLocale(item.category, "name") || "-"}</span>;
      },
      width: 120,
    },
    {
      title: i18n.t("course.album.price"),
      render: (item) => {
        if (isAlbumNotForSale(item)) {
          return <span>—</span>;
        }
        return <span>¥{item.price?.toFixed(2) || "0.00"}</span>;
      },
      width: 100,
    },
    {
      title: i18n.t("course.album.sales"),
      dataIndex: "actual_sold",
      width: 80,
    },
    {
      title: i18n.t("common.statusLabel"),
      render: (item) => {
        return (
          <Badge
            status={item.status === 1 ? "success" : "default"}
            text={item.status_label}
          />
        );
      },
      width: 100,
    },
    {
      title: i18n.t("course.saleTypeFilter"),
      render: (item) => {
        const notForSale = isAlbumNotForSale(item);
        return (
          <Badge
            status={notForSale ? "warning" : "success"}
            text={
              notForSale
                ? i18n.t("course.notForSale")
                : i18n.t("course.forSale")
            }
          />
        );
      },
      width: 110,
    },
    {
      title: i18n.t("shows.sortTypesTitle"),
      dataIndex: "order",
      width: 80,
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 150,
    },
    {
      title: i18n.t("users.actions"),
      width: 250,
      render: (item) => {
        return (
          <>
            <Button
              type="link"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => {
                router.push({
                  pathname: `/main/courses/albums/${item.id}`,
                });
              }}
            >
              {i18n.t("financeHome.listItemActionDetails")}
            </Button>
            <Button
              type="link"
              size="small"
              icon={<EditOutlined />}
              onClick={() => {
                router.push({
                  pathname: `/main/courses/albums/edit`,
                  state: {
                    id: item.id,
                  },
                });
              }}
            >
              {i18n.t("product.productItem.actionEdit")}
            </Button>
            <Popconfirm
              title={i18n.t("sales.deleteWarning")}
              onConfirm={() => {
                setLoading(true);
                deleteMutation.mutate({
                  resource: "course/albums",
                  params: {
                    id: item.id,
                    token,
                  },
                });
              }}
              okText={i18n.t("base.modal.okText")}
              cancelText={i18n.t("base.modal.cancelText")}
            >
              <Button danger type="link" size="small" icon={<DeleteOutlined />}>
                {i18n.t("common.delete")}
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];
};
